export default __webpack_public_path__ + "static/slack-7b8fe4767b55d44ab9167dfb96223d6e.svg";